import { render, staticRenderFns } from "./TouristNameTableCell.vue?vue&type=template&id=cb1ef252&scoped=true"
import script from "./TouristNameTableCell.vue?vue&type=script&lang=js"
export * from "./TouristNameTableCell.vue?vue&type=script&lang=js"
import style0 from "./TouristNameTableCell.vue?vue&type=style&index=0&id=cb1ef252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1ef252",
  null
  
)

export default component.exports